module.exports = __webpack_public_path__ + "img/001-heart.5419146e.svg";